function r(r, t) {
  return t = null == t ? r.length - 1 : +t, function () {
    for (var a = Math.max(arguments.length - t, 0), e = Array(a), n = 0; n < a; n++) e[n] = arguments[n + t];
    switch (t) {
      case 0:
        return r.call(this, e);
      case 1:
        return r.call(this, arguments[0], e);
      case 2:
        return r.call(this, arguments[0], arguments[1], e);
    }
    var l = Array(t + 1);
    for (n = 0; n < t; n++) l[n] = arguments[n];
    return l[t] = e, r.apply(this, l);
  };
}
export { r as default };